var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UkrTreasuresEditingUser',{attrs:{"UT":_vm.UT,"shippingMethods":_vm.shippingMethods},on:{"save":function($event){_vm.save({edit: true, id: _vm.UT.getId()})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }